import { render } from "./UserMenu.vue?vue&type=template&id=9fe82206"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
script.render = render

export default script